<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>Terms and Conditions</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="privacy-policy">Terms and Conditions</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="terms-and-conditions py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="card shadow-lg border-0">
                    <div class="card-body">
                        <h2 class="card-title text-decoration-underline text-center">Terms and Conditions</h2>
                        <h5 class="text-decoration-underline">Welcome to ARNI University, Bringing Ambitions to
                            Life.</h5>
                        <p>We are available on the link https://arni.in/. <b>"We," "Us,"</b> or <b>"Our" </b>: Refers to
                            ARNI
                            University, its subsidiaries, and affiliates. On the other hand, <b>"You"</b> or
                            <b>"User" </b>: Refers to
                            any individual or entity accessing or using the website. Additionally, when we use
                            ‘Content,’ it means that all audio/video work available on the website, regarding ARNI
                            University. </p>
                        <p>We are pleased to have you on the ARNI website and are committed to ensuring that your
                            experience on this platform will be secure, beneficial, and seamless. These ‘Terms and
                            Conditions’ govern your use of our website and the services it offers. By accessing to ARNI
                            website, you agree to comply with these Terms. If you do not agree with any part of these
                            Terms, we kindly ask that you refrain from using our website.
                        </p>
                        <h5 class="text-decoration-underline">Use of ARNI University Website</h5>
                        <p>This is to let users know that the content, pages, and information on the website are free
                            and intended only for general information. The material on the website, however, is accurate
                            to the best of our knowledge and could change at any time without giving users advance
                            warning. Regarding the correctness or sustainability of the information and materials
                            provided, neither we nor any other third parties made any claims. It is completely forbidden
                            to misuse, unauthorized use, sell, or commit fraud with any information, content, or
                            material found on the website. ARNI has the right to take legal action against those who do
                            so.
                        </p>
                        <p>The website and its services are intended solely for lawful purposes. You agree to use the
                            website in compliance with all applicable laws and regulations. You may access the website
                            for personal, educational, or non-commercial use. Any other use requires prior written
                            consent from ARNI University.
                        </p>

                        <h5 class="text-decoration-underline">Prohibited Actions</h5>
                        <p>It is highly prohibited and offensive to engage in any activity that disrupts or interferes
                            with the website’s functionality or security. Moreover, uploading, sharing, or transmitting
                            harmful, defamatory, or illegal content is also restricted. Attempting to gain unauthorized
                            access to the website, its server, or related systems using automated tools such as bots,
                            spiders, or scrapers to extract data from the website without our explicit permission will
                            be considered as misuse of the website.
                        </p>
                        <p><b>Note : </b> You are responsible for your actions while using our website. Any misuse or
                            violation
                            of these Terms may result in suspension or termination of access.
                        </p>
                        <h5 class="text-decoration-underline">Intellectual Property Rights</h5>
                        <p>We take pride and own all rights, interests, and titles including all related IP rights.
                            Content available on the website, including but not limited to images, text, videos,
                            graphics, logos, and software, is the sole property of ARNI University. The content is
                            protected under copyright, trademark, and UP laws. The viewers, visitors, or users may
                            download, or print materials from the website for educational or personal use only.
                        </p>
                        <p>Without any written consent from the officials or appropriate officer, you are not required
                            to modify, reproduce, copy, or distribute any content available on the website including but
                            not limited to commercial purposes. If you believe any content on the website infringes upon
                            your intellectual property rights, please contact us immediately with sufficient details so
                            we can investigate and take appropriate action.
                        </p>
                        <h5 class="text-decoration-underline">User Accounts</h5>
                        <p>Certain features or services of our website may be required to create an account on the
                            platform. While registering, you must provide the accurate, complete, and latest
                            information. False details are subject to account suspension or termination. You are
                            responsible for maintaining your account confidentiality including your unique username and
                            password. Please let us know as soon as possible if you suspect any unauthorized access to
                            your account.</p>

                        <p><b>Note :</b> If we detect any kind of fraudulent activity, misuse, or violation of these
                            terms or any other content available on the platform, ARNI reserves the right to suspend or
                            terminate the account immediately without any prior notice or information.
                        </p>
                        <h5 class="text-decoration-underline">Third-party Links</h5>
                        <p>This is to inform you that the platform may contain links related to third-party websites or
                            services for your convenience. These links are solely provided for information purposes
                            only, we do not own or claim their accuracy and reliability.
                        </p>
                        <p><b class="text-decoration-underline">No Control :</b> ARNI University does not endorse, control, or manage the content
                            policies, information, or any kind of media available on the third-party website, you are
                            required to take appropriate steps to safeguard your information while switching to other
                            sites, at your own risk.
                        </p>
                        <p><b class="text-decoration-underline">Independent Policies :</b> Each website has its own policies, terms and conditions. We
                            always encourage users or viewers to review them before engaging with such platforms as ARNI
                            is not liable for any misinformation or data breaching associated with third-party links or
                            websites.
                        </p>
                        <h5 class="text-decoration-underline">Website Access</h5>
                        <p>Even though we strive to provide the most accurate, reliable, authentic, and up-to-date
                            information on ARNI’s website, we do not guarantee its accuracy, completeness, and
                            timeliness. Also, we are not liable for any delays, errors, bugs, or interruptions in
                            accessing or using our platform, whether due to technical issues or external factors. </p>
                        <h5 class="text-decoration-underline">Indemnification</h5>
                        <p>By using our website, you agree to indemnify and hold harmless ARNI University, its
                            employees, affiliates, and agents from any claims, damages, or liabilities arising from:
                        </p>
                        <ul>
                            <li>Your use of the website.</li>
                            <li>Your violation of these Terms.</li>
                            <li>Your infringement of any third-party rights.</li>
                        </ul>
                        <h5 class="text-decoration-underline">Privacy Policy</h5>
                        <p>To know more about the privacy policy and understand how we collect, use, and safeguard your
                            data, check out our privacy policy page.</p>
                        <h5 class="text-decoration-underline">Changes to Terms and Conditions</h5>
                        <p>ARNI University reserves the right to modify these Terms at any time. Updates will be posted
                            on this page with the "Last Updated" date. Significant changes to these Terms will be
                            communicated through prominent notices on our website or via email.
                        </p>
                        <p><b> Note : </b> Your continued use of the website after any changes signifies your acceptance
                            of the revised Terms.</p>
                        <h5 class="text-decoration-underline">Contact Us</h5>
                        <p>We value your feedback and are here to address your questions or concerns about these Terms
                            and Conditions. Please feel free to contact us:
                        </p>
                        <p>ARNI University Website: arni.in, Email: <a href="mailto:info@arniuniversity.edu.in">info@arniuniversity.edu.in</a>,
                            and Phone: <a href="tel:18008918962">18008918962</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
